import { CONFIRM_SUCCESS_URL } from 'helpers/constants';
import { Api } from 'helpers/ApiClient';
import SalescampHelper from 'helpers/SalescampHelper';
import _ from 'lodash';

export class Auth {
  static async forgotPassword(body) {
    try {
      const response = await Api.client.post(
        '/api/v1/auth/password.json',
        body,
      );
      return response;
    } catch (e) {
      if (e.response && e.response.status !== 500) {
        return {
          status: e.response.status,
          error: e.response.data,
        };
      }
      return {
        error: 'Invalid credentials',
      };
    }
  }

  static async updatePassword(body) {
    try {
      const response = await Api.client.put('/api/v1/auth/password.json', body);
      return response;
    } catch (e) {
      return {
        error: 'Unknown error forgotPassword',
      };
    }
  }

  static async signUp(
    full_name,
    email,
    password,
    agree_to_terms,
    receive_emails,
    reservation_token,
    trial_token,
    expected_accounts,
    expected_plan,
  ) {
    try {
      const referrer_token = SalescampHelper.getTokenFromLocalStorage();
      let bodyFormData = {
        user: {
          full_name,
          email,
          password,
          agree_to_terms,
          confirm_success_url: CONFIRM_SUCCESS_URL,
          receive_emails,
          referrer_token,
        },
        reservation_token,
        trial_token,
        expected_accounts,
        expected_plan,
      };
      const response = await Api.client.post('/api/v1/auth', bodyFormData);
      return response;
    } catch (e) {
      if (e.response.status === 500) {
        return {
          status: 500,
          error: 'Internal server Error',
        };
      } else {
        let errors = e.response.data.errors[0].detail;
        return {
          status: e.response.status,
          error: Object.keys(errors)
            .map(function(v) {
              return `${_.upperFirst(v)} ${errors[v].join(', ')}`;
            })
            .join(', '),
        };
      }
    }
  }

  static async signIn(email, password) {
    try {
      let bodyFormData = {
        user: {
          email,
          password,
        },
      };
      const response = await Api.client.post(
        '/api/v1/auth/sign_in',
        bodyFormData,
      );
      return {
        token: response.headers.authorization,
        status: response.status,
        user: response.data,
      };
    } catch (e) {
      if (e.response && e.response.status === 401) {
        return {
          status: e.response.status,
          error: e.response.data.error,
        };
      }
      console.error('signIn request unknown error: ', e.response);
      return {
        error: 'Unknown error signIn',
      };
    }
  }

  static async signOut() {
    try {
      const response = await Api.client.delete('/api/v1/auth/sign_out.json');
      return response.data;
    } catch (e) {
      console.error('signOut request error: ', e.message);
      return {
        error: 'Unknown error signOut',
      };
    }
  }

  static async updateEmail(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_email',
        body,
      );
      return response.data;
    } catch (e) {
      console.error('signOut request error: ', e.message);
      return {
        error: 'This email has already existed! Try another one!',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/api.js